import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';

import customerFiltersSchema, { CustomerFiltersSchema } from 'core/schemas/customerFilters';
import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';
import ResetButton from 'Elements/Form/ResetButton';
import SearchPane from 'Elements/SearchPane/SearchPane';

const useStyles = makeStyles(theme => ({
  checkbox: {
    padding: '2px 9px'
  },
  formLabel: {
    margin: '10px 0px 10px 15px',
    fontSize: '12px'
  },
  button: {
    marginLeft: theme.spacing(1)
  }
}));

type Props = {
  onSubmit: FormSubmitHandler<CustomerFiltersSchema>;
};

export default function FilterCustomers({ onSubmit }: Props) {
  const classes = useStyles();

  return (
    <SearchPane>
      <Link to={'/customers/create'}>
        <Button fullWidth variant="contained" color="primary">
          Lisää uusi asiakas
        </Button>
      </Link>
      <Typography variant="h6">Suodattimet</Typography>
      <Form
        onSubmit={onSubmit}
        validationSchema={customerFiltersSchema}
        initialValues={{}}
      >
        <InputField
          fullWidth
          name="company"
          variant="outlined"
          placeholder="Hae nimellä"
          margin="normal"
          InputLabelProps={{ shrink: true }}
        ></InputField>

        <InputField
          fullWidth
          name="number"
          variant="outlined"
          placeholder="Hae asiakasnumerolla"
          margin="normal"
          InputLabelProps={{ shrink: true }}
        ></InputField>

        <Grid container justify="flex-end">
          <ResetButton className={classes.button} variant="contained">
            Nollaa
          </ResetButton>
          <SubmitButton
            className={classes.button}
            variant="contained"
            color="secondary"
          >
            Suodata
          </SubmitButton>
        </Grid>
      </Form>
    </SearchPane>
  );
}
